import { lighten } from 'polished';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { iconNextSizeVariant } from '@clds/icon';
const getIconWidth = (props) => 
// @ts-ignore TODO fix types after migration
props.size ? iconNextSizeVariant()?.(props).width : '100%';
const Svg = styled.svg.attrs((props) => ({
    size: props.size || 'md',
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    variant: props.variant || 'primary',
})) `
  width: ${(props) => getIconWidth(props)};
  position: relative;

  path {
    stroke-dasharray: 280;
    stroke-dashoffset: 0;
    transform-origin: center;
  }
`;
const dashKeyframes = keyframes `
    0% { stroke-dashoffset: 560; }
    50% { stroke-dashoffset: 0; }
    100% { stroke-dashoffset: 560;}
`;
export const getColorKeyframes = (color1, color2) => keyframes `
    0% { stroke: ${color1}; }
    50% { stroke: ${color2}; }
    100% { stroke: ${color1}; }
`;
const Path = styled.path `
  animation:
    ${dashKeyframes} 2s ease-in-out infinite,
    ${(props) => props.color1 && props.color2
    ? getColorKeyframes(props.color1, props.color2)
    : getColorKeyframes(
    // @ts-ignore TODO fix after migration
    globalTheme.palette[props.variant](props), 
    // @ts-ignore TODO fix after migration
    lighten(0.2, globalTheme.palette[props.variant](props)))}
      8s ease-in-out infinite;
`;
// eslint-disable-next-line react/display-name
const ProgressLogo = React.forwardRef(({ variant = 'primary', color1, color2, strokeWidth, ...props }, ref) => (React.createElement(Svg, { ref: ref, ...props, viewBox: "-4 -4 151 100", preserveAspectRatio: "xMidYMid", "data-test": "progress" },
    React.createElement(Path
    // eslint-disable-next-line max-len
    , { 
        // eslint-disable-next-line max-len
        d: "M121.663 90.638c-1.796 0-99.33-.498-101.474-1.478C8.685 83.877 1.25 72.196 1.25 59.396c0-16.656 12.797-30.61 29.052-32.323 7.49-15.706 23.186-25.707 40.714-25.707 20.98 0 39.215 14.752 43.945 34.907 15.09.245 27.29 12.63 27.29 27.822 0 11.968-7.738 22.55-19.256 26.33", strokeWidth: strokeWidth ?? '9', strokeLinecap: "round", fill: "none", fillRule: "evenodd", variant: variant, color1: color1, color2: color2 }))));
ProgressLogo.defaultProps = {
//size: 'xl',
};
// eslint-disable-next-line import/no-default-export
export default ProgressLogo;
//# sourceMappingURL=ProgressLogo.js.map